
import { getFunctionUrl } from "./functionEndpoints.js";
import {
  createHttpError,
  withRefreshedAccessTokenRetry,
} from "./googleAuthSession.js";

export const addSheet = async (sheetName, spreadsheetAccessData) => {
  return withRefreshedAccessTokenRetry(
    spreadsheetAccessData,
    async (nextAccessData) => {
      const response = await fetch(getFunctionUrl('make-sheet'),
        {'body': JSON.stringify({
          ...nextAccessData,
          sheetName: sheetName
          }),
          'method': 'POST',
          'headers':
            {'Content-Type': 'application/json'}
        }
      );
      if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw createHttpError(
          body?.error || `make-sheet failed with status ${response.status}`,
          response.status,
          body
        );
      }
      return response;
    }
  );
}
export default addSheet;
